import {createCallSignals} from '@pexip/infinity';

export const callSignals = createCallSignals([]);
